/* eslint no-console:0 */
const componentRequireContext = require.context('components', true)
const ReactRailsUJS = require('react_ujs')

// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(componentRequireContext)
